const DistrictIcon = (props: any) => {
  return (
    <div>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1380_43954)">
          <path
            d="M18 10.9545C18 16.3636 11.5 21 11.5 21C11.5 21 5 16.3636 5 10.9545C5 9.11009 5.68482 7.34117 6.90381 6.03694C8.12279 4.73271 9.77609 4 11.5 4C13.2239 4 14.8772 4.73271 16.0962 6.03694C17.3152 7.34117 18 9.11009 18 10.9545Z"
            fill="none"
          />
          <path
            d="M11.5 13.2727C12.6966 13.2727 13.6667 12.2348 13.6667 10.9545C13.6667 9.67425 12.6966 8.63636 11.5 8.63636C10.3034 8.63636 9.33333 9.67425 9.33333 10.9545C9.33333 12.2348 10.3034 13.2727 11.5 13.2727Z"
            fill="none"
          />
          <path
            d="M18 10.9545C18 16.3636 11.5 21 11.5 21C11.5 21 5 16.3636 5 10.9545C5 9.11009 5.68482 7.34117 6.90381 6.03694C8.12279 4.73271 9.77609 4 11.5 4C13.2239 4 14.8772 4.73271 16.0962 6.03694C17.3152 7.34117 18 9.11009 18 10.9545Z"
            stroke={props?.color ?? "black"}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.5 13.2727C12.6966 13.2727 13.6667 12.2348 13.6667 10.9545C13.6667 9.67425 12.6966 8.63636 11.5 8.63636C10.3034 8.63636 9.33333 9.67425 9.33333 10.9545C9.33333 12.2348 10.3034 13.2727 11.5 13.2727Z"
            stroke={props?.color ?? "black"}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.1667 20.8C22.1667 21.0271 22.0185 21.3354 21.5314 21.6953C21.054 22.048 20.3313 22.3867 19.3934 22.6798C17.5234 23.2641 14.9094 23.6333 12 23.6333C9.09071 23.6333 6.47667 23.2641 4.60671 22.6798C3.66874 22.3867 2.94607 22.048 2.46873 21.6953C1.98161 21.3354 1.83337 21.0271 1.83337 20.8C1.83337 20.5729 1.98161 20.2645 2.46873 19.9046C2.94607 19.552 3.66874 19.2133 4.60671 18.9202C6.47667 18.3358 9.09071 17.9667 12 17.9667C14.9094 17.9667 17.5234 18.3358 19.3934 18.9202C20.3313 19.2133 21.054 19.552 21.5314 19.9046C22.0185 20.2645 22.1667 20.5729 22.1667 20.8Z"
            stroke={props?.color ?? "black"}
          />
        </g>
        <defs>
          <clipPath id="clip0_1380_43954">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default DistrictIcon;
